module.exports = __webpack_public_path__ + "img/icon2.536aeec1.png";